import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Theme } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class ThemesService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  getThemes() {
    return this.http.get<Theme[]>(`${this.BASE_URL}api/themes`);
    // return this.http.get<Theme[]>(`${this.BASE_URL}assets/themes.json`);
  }
}
